import Button from '@pelckmans/elementis/components/button';
import Dialog from '@pelckmans/elementis/components/dialog';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Member } from '../../../../../../../api/groups';
import ModalContext from '../../../../../../../contexts/ModalContext';

type Props = {
  id: string;
  student: Member;
  onConfirm: (student: Member) => void;
};

function DeleteMemberModal({ id, student, onConfirm }: Props) {
  const { t } = useTranslation();
  const { closeModal } = useContext(ModalContext);

  const handleClose = () => {
    closeModal(id);
  };

  const modalTitle =
    student.status === 'accepted'
      ? t('PAGES.MY_GROUPS.MODALS.REMOVE_MEMBER_GROUP.ACCEPTED.TITLE')
      : t('PAGES.MY_GROUPS.MODALS.REMOVE_MEMBER_GROUP.INVITED.TITLE');
  const modalMessage =
    student.status === 'accepted'
      ? t('PAGES.MY_GROUPS.MODALS.REMOVE_MEMBER_GROUP.ACCEPTED.MESSAGE')
      : t('PAGES.MY_GROUPS.MODALS.REMOVE_MEMBER_GROUP.INVITED.MESSAGE');
  const modalActionText =
    student.status === 'accepted'
      ? t('PAGES.MY_GROUPS.MODALS.REMOVE_MEMBER_GROUP.ACCEPTED.ACTIONS.CONFIRM')
      : t('PAGES.MY_GROUPS.MODALS.REMOVE_MEMBER_GROUP.INVITED.ACTIONS.CONFIRM');

  return (
    <Dialog
      id={id}
      modal
      size="md"
      onClose={handleClose}
      aria-label={t('PAGES.MY_GROUPS.MODALS.REMOVE_MEMBER_GROUP.A11Y_LABEL')}
    >
      <Dialog.Header
        title={modalTitle}
        onClose={handleClose}
        aria-label={t('PAGES.MY_GROUPS.MODALS.REMOVE_MEMBER_GROUP.HEADER.ACTIONS.CLOSE')}
      />
      <Dialog.Body>{modalMessage}</Dialog.Body>
      <Dialog.Footer
        buttonGroupPropsRight={{
          'aria-label': undefined,
          role: undefined,
          children: (
            <>
              <Button prominence="neutral" onClick={handleClose} key="cancel">
                {t('PAGES.MY_GROUPS.MODALS.REMOVE_MEMBER_GROUP.FOOTER.ACTIONS.CANCEL')}
              </Button>
              <Button
                prominence="danger"
                onClick={() => {
                  onConfirm(student);
                  closeModal(id);
                }}
                key="confirm"
              >
                {modalActionText}
              </Button>
            </>
          ),
        }}
      />
    </Dialog>
  );
}

export default DeleteMemberModal;
